import React, { useState, useEffect, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import { splitStringAtFirstOccurrence } from '@Utilities/StringUtils';

const ServiceLogSection = (props) => {

    const handleFormUpdateForServiceLogs = props.handleFormUpdateForServiceLogs;
    let masterViewModel = props.masterViewModel;

    const initialRender = useRef(true);

    const [logFormats, setLogFormats] = useState('');
    const [logTypes, setLogTypes] = useState([]);
    const activeIntervals = useRef([]);
    var progressList = [];
    const currentLogCount = useRef(0);
    const currentLogPlaceholderCount = useRef(0);
    const sShowFileNameRef = useRef('');
    var isLogSaveBusy = useRef(false);
    const [bShowLogMaxError, setbShowLogMaxError] = useState(false);
    const [bShowFileSizeError, setbShowFileSizeError] = useState(false);
    const [bShowFileUploadError, setbShowFileUploadError] = useState(false);
    const [bShowFileTypeError, setbShowFileTypeError] = useState(false);
    const [sShowFileTypeError, setsShowFileTypeError] = useState('');
    const [sShowFileName, setsShowFileName] = useState('');

    const lstLogFormats = useRef([]);

    useEffect(() => {
        masterViewModel.validatorLogs = validatorLogs;
        handleFormUpdateForServiceLogs(masterViewModel);

        var options = {
            logSortElementID: props.model.logSortElementID,
            AppendTarget: $('#serviceLogs')
        };

        LoadServiceLogsModal(props.model, options);

        setLogFormats($('#hfLogFormats').val().toString().replace(/,/g, ",."));
        lstLogFormats.current = $('#hfLogFormats').val().toString().replace(/,/g, ",.");
        setLogTypes($('#hfLogTypes').val().toString().split(","));

        populateExistingLogs(props.model);

        let dropbox;
        dropbox = document.getElementById("serviceLogDropbox");
        dropbox.addEventListener("dragenter", dragenter, false);
        dropbox.addEventListener("dragover", dragover, false);
        dropbox.addEventListener("drop", drop, false);

        $('#uploader_browse').html(ReactDOMServer.renderToString(getTranslation("AddFiles")));
        $('#uploader_selectfiles').html(ReactDOMServer.renderToString(getTranslation("SelectFiles")));
        $('#uploader_filename').html(ReactDOMServer.renderToString(getTranslation("Filename")));
        $('#uploader_size').html(ReactDOMServer.renderToString(getTranslation("Size")));
        $('#uploader_status').html(ReactDOMServer.renderToString(getTranslation("Status")));
    }, []);

    useEffect(() => {
        masterViewModel = props.masterViewModel;
    }, [props]);

    function uploadCompletedMethod(uploadedFileName, response) {
        LogFileAdded(uploadedFileName, response.mediaId);
        document.getElementById("logUpload-input").value = null;
    }

    function LogFileAdded(filename, nMediaID, setTimeoutInterval) {
        var fileLink = "";

        var state = {
            mediaID: nMediaID
        };

        setTimeout(function () {
            $.ajax({
                type: "POST",
                url: '/ListingInput/servicelog/GetServiceLogPath' + props.model.QueryString,
                data: JSON.stringify(state),
                dataType: "json",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function (result) {
                    fileLink = result.path;
                    replacePlaceholderForLogFile(nMediaID, "", filename, fileLink, $('#hfLogTypes').val().toString().split(","));
                    UpdateLogsInXML(true);
                }
            });
        }, setTimeoutInterval);
    }

    function dragenter(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    function dragover(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    function drop(e) {
        e.stopPropagation();
        e.preventDefault();

        const dt = e.dataTransfer;
        const files = dt.files;

        uploadServiceLog(files);
    }

    //handles all UI loader updating
    function handleUploadLoaderProgress(currentFile, progress) {
        var fileIndex = progressList.findIndex(obj => obj.name == currentFile.name);
        var progressTextSetInterval;
        var progressBarSetInterval;
        var maxProgressBeforeLog = 99;

        //only progress to this number until we get another update from the ajax event progress handler
        var maxProgressForCurrentGroup = progressList[fileIndex] != undefined ? (progressList[fileIndex].value * .9).toFixed(0) : maxProgressBeforeLog;

        var groupInterval = 50;
        var progressNumInterval = 200;
        var logGroupInterval = 1000;

        if (progress == 0) {
            activeIntervals.current = (removeInactiveLogIntervals(activeIntervals.current, currentFile));
        }

        if (progress <= maxProgressBeforeLog) {

            //interval for progress text
            progressTextSetInterval = setInterval(function () {
                renderLogProgress(currentFile.name, progress, progress, activeIntervals.current);
            }, progressNumInterval);

            //interval for progress bar
            progressBarSetInterval = setInterval(function () {
                if (progress > maxProgressForCurrentGroup || progress > maxProgressBeforeLog) {
                    //stop updating, move onto new progress group
                    renderLogProgress(currentFile.name, progress - 1, progress - 1, activeIntervals.current);
                    activeIntervals.current = (Object.values(activeIntervals.current).filter(item => item.value != progressTextSetInterval));
                    clearInterval(progressTextSetInterval);
                    progressTextSetInterval = undefined;

                    activeIntervals.current = (Object.values(activeIntervals.current).filter(item => item.value != progressBarSetInterval));
                    clearInterval(progressBarSetInterval);
                    progressBarSetInterval = undefined;

                    handleUploadLoaderProgress(currentFile, progress);
                }
                else if (progress <= maxProgressForCurrentGroup && progress <= maxProgressBeforeLog) {
                    renderLogProgress(currentFile.name, progress, 0, activeIntervals.current);
                    progress++;
                }
            }, groupInterval);

            activeIntervals.current = ([...activeIntervals.current, { value: progressTextSetInterval, name: currentFile.name }, { value: progressBarSetInterval, name: currentFile.name }]);
        }
        else if (progress > 90 && progress <= 99) {

            //interval for progress text and bar
            progressBarSetInterval = setInterval(function () {
                if (progress > 99) {
                    //stop updating, move onto new progress group
                    activeIntervals.current = (Object.values(activeIntervals.current).filter(item => item.value != progressBarSetInterval));
                    clearInterval(progressBarSetInterval);
                    progressBarSetInterval = undefined;

                    handleUploadLoaderProgress(currentFile, progress);
                }
                else if (progress <= 99) {
                    renderLogProgress(currentFile.name, progress, progress, activeIntervals.current);
                    progress++;
                }
            }, logGroupInterval);
        }
    }

    function uploadServiceLog(files) {   //called for every file upload attempt         
        var maxLogCount = 40;

        var logs = document.getElementById("sortableLogs");

        currentLogCount.current = logs.children.length;
        currentLogPlaceholderCount.current = currentLogCount.current;

        setbShowLogMaxError(false);
        setbShowFileSizeError(false);
        setbShowFileUploadError(false);
        setbShowFileTypeError(false);
        setsShowFileTypeError("");
        setsShowFileName("");
        sShowFileNameRef.current = "";

        for (let i = 0; i < files.length; i++) {
            if (files[i].size > 2147483648) {
                setbShowFileSizeError(true);
            }
            else {
                var sFileExtension = files[i].name.split(".").pop().toLowerCase();
                if (lstLogFormats.current.includes(sFileExtension) && currentLogPlaceholderCount.current < maxLogCount) {
                    //create placeholder box for loading progress
                    currentLogPlaceholderCount.current = currentLogPlaceholderCount.current + 1;
                    document.getElementById('sortableLogs').appendChild(createLogProgressLoaderElement(files[i].name));
                    document.getElementsByClassName('uploader-logs')[0].style.display = "block";
                }
            }
        }

        for (let i = 0; i < files.length; i++) {

            var fd = new FormData();
            var nextChunk = 0;
            var chunkSize = 2097152;
            if (files[i].size > 2147483648) {
                setbShowFileSizeError(true);
            }
            else {
                if (files[i].size > 2097152) {
                    chunkSize = 1048576; //if file is over 2MB, send it in 1MB chunks
                }
                var currentFile = files[i];
                var sFileExtension = currentFile.name.split(".").pop().toLowerCase();

                var fileType = (lstLogFormats.current.includes(sFileExtension) ? "valid" : "invalid");

                if (fileType == "invalid") {
                    if (bShowFileTypeError == true) {
                        setsShowFileTypeError(sShowFileTypeError + ", ." + currentFile.name.split(".").pop().toLowerCase());
                    }
                    else {
                        setbShowFileTypeError(true);
                        setsShowFileTypeError("." + currentFile.name.split(".").pop().toLowerCase());
                    }
                }
                else {

                    var totalChunks = Math.ceil(currentFile.size / chunkSize);
                    var bAsync = true;
                    fd.append("file", currentFile.slice(0, chunkSize)); //get first chunk

                    if (currentLogCount.current < maxLogCount) { // only upload if max isn't reached
                        currentLogCount.current = currentLogCount.current + 1;

                        progressList.push({ value: 0, currentChunk: nextChunk + 1, numChunks: totalChunks, name: currentFile.name });
                        startUpload(fd, files, currentFile, chunkSize, nextChunk, totalChunks, bAsync)
                    }
                }
            }
        }

        if (currentLogCount.current >= 40) {
            setbShowLogMaxError(true);
        }
    }

    function logUploadError(currentFile, status, chunk, totalChunks, chunkSize, textStatus) {
        if (status == 200) {
            return;
        }

        const chunkStart = chunk * chunkSize;
        const currentChunkSize = Math.min(chunkSize, Math.max(0, currentFile.size - chunkStart));
        $.ajax({
            type: "POST",
            url: '/listinginput/ajax/LogMessage',
            data: JSON.stringify({ 'sErrorMessage': `Service log upload failed for ${currentFile.name} with HTTP status ${status}; reason=${textStatus || "unknown"}. Chunk index (0-based) ${chunk}; total chunks ${totalChunks}; chunk size ${currentChunkSize} bytes; file size ${currentFile.size} bytes.` }),
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8"
        });
    }

    function startUpload(fd, files, currentFile, chunkSize, nextChunk, totalChunks, bAsync) {
        handleUploadLoaderProgress(currentFile, 0);

        setTimeout(function () {
            $.ajax({
                type: "POST",
                url: `/listinginput/servicelog/UploadServiceLog/?chunk=${nextChunk}&chunks=${totalChunks}&fileName=${encodeURIComponent(currentFile.name)}`,
                data: fd,
                datatype: 'json',
                async: bAsync,
                contentType: false,
                processData: false,
                success: function (result) {
                    let response = JSON.parse(result);
                    uploadMoreChunks(fd, files, currentFile, response, chunkSize, (nextChunk + 1), totalChunks, bAsync);
                },
                error: function (jqXHR, textStatus) {
                    logUploadError(currentFile, jqXHR.status, nextChunk, totalChunks, chunkSize, textStatus);
                    let response = {
                        message: "File upload failed",
                        mediamessage: "Media Upload threw an error for a service log."
                    };
                    //send error message to this function to show error on UI
                    uploadMoreChunks(fd, files, currentFile, response, chunkSize, (nextChunk + 1), totalChunks, bAsync);
                },
                xhr: function () {
                    // get the native XmlHttpRequest object                    
                    var xhr = $.ajaxSettings.xhr();
                    // set the onprogress event handler
                    xhr.upload.onprogress = function (evt) {
                        var fileIndex = progressList.findIndex(obj => obj.name == currentFile.name);
                        if (fileIndex > -1 && progressList[fileIndex] != undefined) {
                            progressList[fileIndex].value = (((evt.loaded / evt.total) * 100) / progressList[fileIndex].numChunks) * progressList[fileIndex].currentChunk;
                            progressList[fileIndex].currentChunk = nextChunk;
                        }
                    };
                    // return the customized object
                    return xhr;
                }
            });
        }, 50);
    }

    function uploadMoreChunks(fd, files, currentFile, response, chunkSize, nextChunk, totalChunks, bAsync) {
        if (response.message == "File Chunk Uploaded Correctly") {
            fd = new FormData();
            fd.append("file", currentFile.slice(nextChunk * chunkSize, ((nextChunk * chunkSize) + chunkSize))); //get next chunk

            $.ajax({
                type: "POST",
                url: `/listinginput/servicelog/UploadServiceLog/?chunk=${nextChunk}&chunks=${totalChunks}&fileName=${encodeURIComponent(currentFile.name)}`,
                data: fd,
                datatype: 'json',
                async: bAsync,
                contentType: false,
                processData: false,
                success: function (result) {
                    var response = JSON.parse(result);
                    uploadMoreChunks(fd, files, currentFile, response, chunkSize, (nextChunk + 1), totalChunks, bAsync);
                },
                error: function (jqXHR, textStatus) {
                    logUploadError(currentFile, jqXHR.status, nextChunk, totalChunks, chunkSize, textStatus);
                    uploadMoreChunks(fd, files, currentFile, {
                        message: "File upload failed",
                        mediamessage: "Media Upload threw an error for a service log."
                    }, chunkSize, nextChunk + 1, totalChunks, bAsync);
                },
                xhr: function () {
                    // get the native XmlHttpRequest object
                    var xhr = $.ajaxSettings.xhr();
                    // set the onprogress event handler
                    xhr.upload.onprogress = function (evt) {
                        var fileIndex = progressList.findIndex(obj => obj.name == currentFile.name);
                        if (fileIndex > -1 && progressList[fileIndex] != undefined) {
                            progressList[fileIndex].value = (((evt.loaded / evt.total) * 100) / progressList[fileIndex].numChunks) * progressList[fileIndex].currentChunk;
                            progressList[fileIndex].currentChunk = nextChunk;
                        }
                    };
                    // return the customized object
                    return xhr;
                }
            });
        }
        else if (response.bSuccess === false || (response.message && response.message.includes("File upload failed"))) {
            removePlaceholderForLogFile(currentFile.name);
            activeIntervals.current = (removeInactiveIntervals(activeIntervals.current, currentFile));
            progressList = progressList.filter(obj => obj.name != currentFile.name);

            var logs = document.getElementById("sortableLogs");
            if (logs?.children?.length == 0)
                $('.uploader-logs').hide();

            if (sShowFileNameRef.current == "") {
                sShowFileNameRef.current = currentFile.name.toString();
                setsShowFileName(currentFile.name);
            }
            else {
                var tempFileNames = sShowFileNameRef.current.toString();
                sShowFileNameRef.current = tempFileNames.toString() + ", " + currentFile.name.toString();
                setsShowFileName(tempFileNames.toString() + ", " + currentFile.name.toString());
            }
            setbShowFileUploadError(true);

        }
        else {
            progressList = progressList.filter(obj => obj.name != currentFile.name);
            var fileSortIDs = []
            for (let i = 0; i < files.length; i++) {
                fileSortIDs.push(files[i].name);
            }

            addInfoToLogLoaderElement(currentFile.name, response.mediaId, "", "0");
            uploadCompletedMethod(currentFile.name, response);
        }
    }

    const getTranslation = (key) => {
        return props.masterViewModel.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: props.model.Translations[key] }}></span> :
            props.model.Translations[key];
    };

    const validatorLogs = (bButtonPress) => {
        $('#ServiceLogErrorMessage').hide();

        if (bButtonPress) {
            ServiceLogSectionDone(masterViewModel.IsRearrangedDetailsPage);
        }

        return true;
    };

    const getExpandedIntellectualPropertyDisclaimer = () => {
        if ($('#LogIntellectualPropertyDisclaimerPartTwo').css("display") == 'none') {
            $('#LogIntellectualPropertyDisclaimerPartTwo').show();
            $('#LogExpandDisclaimerTxt').text(getTranslation("Less"));
        }
        else {
            $('#LogIntellectualPropertyDisclaimerPartTwo').hide();
            $('#LogExpandDisclaimerTxt').text(getTranslation("More") + "...");
        }
    }

    let enhanceVisibilityTranslation = getTranslation("EnhanceVisibility");
    let enhanceVisibilitySplit = splitStringAtFirstOccurrence(enhanceVisibilityTranslation, ".");
    let boldedSectionOfEnhanceVisibility = enhanceVisibilitySplit.after;
    let renderedSection = null;

    if (props.masterViewModel.IsRearrangedDetailsPage) {
        renderedSection = <strong>{boldedSectionOfEnhanceVisibility}</strong>;
    }

    return (
        <div className="accordion cf" id="accordion-content-6" style={{ paddingTop: '0px' }}>
            <div id="serviceLogs">
                <div>
                    <p>{getTranslation("IntellectualPropertyDisclaimerPartOne")}
                        &nbsp;<span id="LogIntellectualPropertyDisclaimerPartTwo" dangerouslySetInnerHTML={{ __html: getTranslation("IntellectualPropertyDisclaimerPartTwo") }} style={{ display: 'none' }}></span>
                        &nbsp;<a id="LogExpandDisclaimerTxt" role="alert" tabIndex="0" onClick={() => getExpandedIntellectualPropertyDisclaimer()} className="inLblLinkBlue">{getTranslation("More") + "..."}</a>
                    </p>
                    <p>{renderedSection}</p>

                    {getTranslation("IntellectualPropertyDisclaimerPartThree")}

                    {/*new file upload UI*/}
                    <div style={{ textAlign: "center", fontSize: "15px", wordWrap: "break-word" }} className="validationError">
                        {bShowLogMaxError ? <p id="LogUploadError" style={{ display: "block" }}>{getTranslation("MaxLogUploadError")}</p> : null}
                        {bShowFileSizeError ? <p id="FileSizeUploadError" style={{ display: "block" }}>{getTranslation("MaxFileSizeError")}</p> : null}
                        {bShowFileUploadError ? <p id="FileUploadError" style={{ display: "block" }}>{sShowFileName}: {getTranslation("FileUploadError")}</p> : null}
                        {bShowFileTypeError ? <p id="FileTypeUploadError" style={{ display: "block" }}>{getTranslation("FileTypeError")}: {sShowFileTypeError}</p> : null}
                        {bShowFileTypeError ? <p id="SupportedFileTypes" style={{ display: "block" }}>{getTranslation("SupportedFileTypes")}: {"." + logFormats}</p> : null}
                    </div>
                    <label id="serviceLogDropbox" className="log upload-box">
                        <input id="logUpload-input"
                            accept={"." + logFormats}
                            type="file"
                            multiple
                            onChange={(event) => { uploadServiceLog(event.target.files); }}
                        />
                        <strong>{getTranslation("DragOrClickToUpload")}</strong>
                        <span className="svg-container">
                            <svg className='fontawesomesvg' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                <path d="M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z" />
                            </svg>
                        </span>
                    </label>
                </div>
            </div>
            <button role="link" onClick={() => validatorLogs(true)} className="form-btn" id="service-log-btn">{getTranslation("DoneWithLogs")}</button>
        </div>
    );
};

export default ServiceLogSection;
global.ServiceLogSection = ServiceLogSection;